// extracted by mini-css-extract-plugin
export var cartIcon = "_jx-0";
export var cartIconContainer = "_jx-1";